export default __webpack_public_path__ + "static/media/33.04be54f4.mp3";